"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SearchSelect = require("../SearchSelect");
var _Option = _interopRequireDefault(require("./components/Option"));
var _SingleValue = _interopRequireDefault(require("./components/SingleValue"));
var _styles = require("./styles");
var Selector = function Selector(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? {
      id: '',
      value: ''
    } : _props$selected,
    _props$onSelected = props.onSelected,
    onSelected = _props$onSelected === void 0 ? function () {
      return null;
    } : _props$onSelected;
  var handleChange = function handleChange(opt) {
    return onSelected({
      id: opt === null || opt === void 0 ? void 0 : opt.value,
      value: opt === null || opt === void 0 ? void 0 : opt.label,
      description: opt === null || opt === void 0 ? void 0 : opt.description
    });
  };
  var value = {
    value: selected.id,
    label: selected.value || defaultValue
  };
  var selectOptions = options.map(function (o) {
    return {
      value: o.id,
      label: o.value,
      description: o.description
    };
  });
  return /*#__PURE__*/_react["default"].createElement(StyledSelector, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_SearchSelect.SearchSelect, {
    value: value,
    options: selectOptions,
    onChange: handleChange,
    customStyles: _styles.selectStyles,
    CustomSingleValue: _SingleValue["default"],
    CustomDropdownIndicator: function CustomDropdownIndicator() {
      return null;
    },
    CustomOption: _Option["default"],
    isSearchable: false,
    menuShouldScrollIntoView: true
  }));
};
var StyledSelector = _styledComponents["default"].div.withConfig({
  displayName: "Selector__StyledSelector",
  componentId: "sc-18u997x-0"
})(["position:relative;cursor:pointer;"]);
var _default = exports["default"] = Selector;